<template>
    <div class="">
        <span v-if="durationInSeconds <= 0"> -- </span>
        <span>
            {{ durationReadable }}
        </span>
    </div>
</template>
<script>
export default {
    name: "media-duration",
    props: {
        durationInSeconds: {
            type: Number,
            default: 0,
        },
        showSeconds: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        durationReadable() {
            let hours = Math.floor(this.durationInSeconds / 3600);
            let minutes = Math.floor(this.durationInSeconds / 60) % 60;
            let seconds = this.durationInSeconds % 60;

            return [hours, minutes, seconds]
                .map((v) => (v < 10 ? "0" + v : v))
                .filter((v, i) => v !== "00" || i > 0)
                .join(":");
        },
    },
};
</script>
